import Client from "./client";

const baseUrl = `/api/1/trades`;

function trades() {
  return {
    getRecentMarkets: ({ params }) => {
      const url = baseUrl + `/recent/market/${params.market}`;
      return Client.getWithoutLoading(url);
    },
    getMytrades: ({ params }) => {
      const url = baseUrl + `/self/${params.pageSize}/${params.pageNumber}`;
      return Client.get(url);
    },
  };
}

export default trades();
